import React from 'react'

export const Card = props => (
  <div className={`card ${props.className || ''}`} style={props.style} {...props}>
    {props.children}
  </div>
)

export default Card
